export const MAIL_SEND_SUCCEFFSUL = 'MAIL_SEND';
export const MAIL_SEND_FAILED = 'MAIL_SEND_FAILED';
export const MAIL_SEND_REQUESTED = 'MAIL_SEND_REQUESTED';




// WEBPACK FOOTER //
// ./src/components/SendGrid/actionTypes.js